import React from 'react';
import { isNil } from 'lodash';
import PercentInput from 'components/PercentInput';
import { round } from 'utils/number';

type Props = {
  source: string;
};

// Admin-editable. Labeled "multiplier" because it modifies the pro pay rate,
// but the stored field stays blended_rate_markup. The rate controller watches
// it and refreshes the read-only 12hr Charge Rate.
// format/parse override PercentInput's defaults so an unset value renders
// blank (not "0") and clearing the field stores null (not NaN) — null falls
// back to the inherited value, while an explicit 0 is a real value.
export const BlendedRateMarkupInput = ({ source }: Props) => {
  return (
    <PercentInput
      source={`${source}.blended_rates.blended_rate_markup`}
      label="Blended Rate Multiplier"
      format={(v) => (isNil(v) || v === '' ? '' : round(v * 100))}
      parse={(v) => {
        const parsed = parseFloat(v);
        return Number.isNaN(parsed) ? null : round(parsed / 100);
      }}
    />
  );
};
